interface RaffleAncolState {
  raffles: any[];
  raffleDetail: any;
  isLoading: boolean;
  isFormLoading: boolean;
  currentPage: number;
  totalPage: number;
  limitPage: number;
  lengthPage: number;
}

const initialState: RaffleAncolState = {
  raffles: [],
  raffleDetail: null,
  isLoading: false,
  isFormLoading: false,
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 0,
};

export const raffleAncolReducer = (
  state = initialState,
  action: any
): RaffleAncolState => {
  switch (action.type) {
    case "SET_RAFFLE_ANCOL_LOADING":
      return { ...state, isLoading: action.payload };
    case "SET_RAFFLE_ANCOL_FORM_LOADING":
      return { ...state, isFormLoading: action.payload };
    case "GET_ALL_RAFFLE_ANCOL":
      return { ...state, raffles: action.payload };
    case "SET_RAFFLE_ANCOL_DETAIL":
      return { ...state, raffleDetail: action.payload };
    case "SET_RAFFLE_ANCOL_PAGINATION":
      return {
        ...state,
        currentPage: action.payload.currentPage,
        totalPage: action.payload.totalPage,
        limitPage: action.payload.limitPage,
        lengthPage: action.payload.lengthPage,
      };
    case "ADD_RAFFLE_ANCOL":
      return { ...state, raffles: [action.payload, ...state.raffles] };
    case "UPDATE_RAFFLE_ANCOL":
      return {
        ...state,
        raffles: state.raffles.map((raffle) =>
          raffle.id === action.payload.id ? action.payload : raffle
        ),
      };
    case "DELETE_RAFFLE_ANCOL":
      return {
        ...state,
        raffles: state.raffles.filter((raffle) => raffle.id !== action.payload),
      };
    default:
      return state;
  }
};
